function CartIcon({ ...rest }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' {...rest}>
      <path
        d='M7.54474 18.1813C7.99661 18.1813 8.36293 17.815 8.36293 17.3631C8.36293 16.9112 7.99661 16.5449 7.54474 16.5449C7.09287 16.5449 6.72656 16.9112 6.72656 17.3631C6.72656 17.815 7.09287 18.1813 7.54474 18.1813Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.5447 18.1813C16.9966 18.1813 17.3629 17.815 17.3629 17.3631C17.3629 16.9112 16.9966 16.5449 16.5447 16.5449C16.0929 16.5449 15.7266 16.9112 15.7266 17.3631C15.7266 17.815 16.0929 18.1813 16.5447 18.1813Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 1H4.27273L6.46545 11.9555C6.54027 12.3321 6.7452 12.6705 7.04436 12.9113C7.34351 13.1522 7.71784 13.2801 8.10182 13.2727H16.0545C16.4385 13.2801 16.8129 13.1522 17.112 12.9113C17.4112 12.6705 17.6161 12.3321 17.6909 11.9555L19 5.09091H5.09091'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default CartIcon;
